import {
  LOGIN_NO_ACCOUNT_FOUND,
  LOGIN_ERROR,
  LOGIN_ACCOUNT_EXISTS,
  LOGIN_ACCOUNT_EXISTS_WITHOUT_NAME,
  RESET_LOGIN_DATA,
  LOGIN_ACCOUNT_WITH_EMPTY_TNC,
  LOGIN_ACCOUNT_SUSPENDED,
} from '../constants'

const initialState = {
  phoneNumber: '',
  countryCode: '',
  doesAccountExist: false,
  isEmailRequired: false,
  isNameRequired: false,
  profileId: '',
  isTncEmpty: false,
  isLoginError: false,
  accountSuspended: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_NO_ACCOUNT_FOUND:
      return {
        ...state,
        phoneNumber: action.response.phone_number,
        countryCode: action.response.country_code,
        isEmailRequired: true,
      }
    case LOGIN_ACCOUNT_EXISTS:
      return {
        ...state,
        profileId: action.response.profileId,
        doesAccountExist: true,
      }
    case LOGIN_ACCOUNT_EXISTS_WITHOUT_NAME:
      return {
        ...state,
        phoneNumber: action.response.phone_number,
        countryCode: action.response.country_code,
        profileId: action.response.profileId,
        isNameRequired: true,
      }
    case RESET_LOGIN_DATA:
      return {
        ...state,
        doesAccountExist: false,
        isEmailRequired: false,
        isNameRequired: false,
        isTncEmpty: false,
        isLoginError: false,
      }
    case LOGIN_ACCOUNT_WITH_EMPTY_TNC:
      return {
        ...state,
        phoneNumber: action.response.phone_number,
        countryCode: action.response.country_code,
        profileId: action.response.profileId,
        isTncEmpty: true,
      }
    case LOGIN_ACCOUNT_SUSPENDED:
      return {
        ...state,
        accountSuspended: true,
      }
    case LOGIN_ERROR:
      return {
        ...state,
        ...action.response,
        isLoginError: true,
      }
    default:
      return state
  }
}

